import { RxCustomerAPI } from '@driftt/dapper'
import { CustomerAPIAuthEnabled } from 'app/auth-requests/api'
import { Observable } from 'rxjs'
import { encodeQueryData } from 'utils/Helpers'

import { TeamAvailabilitySettings } from './models'

export const api = {
  fetchTeams() {
    return Observable.fromPromise(
      CustomerAPIAuthEnabled
      .get(`/teams`)
      .then(res => res.data))
  },

  fetchTeamsForUser({ userId }) {
    return RxCustomerAPI.get(`/teams?${encodeQueryData({ userId })}`)
      .checkStatus()
      .map(res => res.response)
  },

  createTeam({ team }) {
    return RxCustomerAPI.post(`/teams`, team)
      .checkStatus()
      .map(res => res.response)
  },

  patchTeam({ teamId, properties }) {
    return RxCustomerAPI.patch(`/teams/${teamId}`, properties)
      .checkStatus()
      .map(res => res.response)
  },

  updateAvailabilityForTeam({ teamId, teamAvailabilitySettings }) {
    return RxCustomerAPI.put(
      `/availabilities/team/${teamId}`,
      TeamAvailabilitySettings(teamAvailabilitySettings).toJS()
    )
      .checkStatus()
      .map(res => res.response)
  },

  fetchTeamAvailabilities() {
    return Observable.fromPromise(
      CustomerAPIAuthEnabled
      .get(`/availabilities`)
      .then(res => res.data))
  },

  fetchAvailabilityById({ teamAvailabilityId }) {
    return RxCustomerAPI.get(`/availabilities/${teamAvailabilityId}`)
      .checkStatus()
      .map(res => res.response)
  },

  createTeamAvailability({ teamAvailabilitySettings }) {
    return RxCustomerAPI.post(`/availabilities`, teamAvailabilitySettings)
      .checkStatus()
      .map(res => res.response)
  },

  updateTeamAvailability({ teamAvailabilityId, teamAvailabilitySettings }) {
    return RxCustomerAPI.post(`/availabilities/${teamAvailabilityId}`, teamAvailabilitySettings)
      .checkStatus()
      .map(res => res.response)
  },
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/teams/api.js